import Button from "@pathwright/ui/src/components/button/Button"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import { DISCUSSION_TYPE_POST } from "@pathwright/web/src/modules/discussion/constants"
import Discussions from "@pathwright/web/src/modules/discussion/list"
import {
  DISCUSSION_CONTROL_FILTER_DISCUSSION_QUESTIONS,
  DISCUSSION_CONTROL_SORT_STEP_DISCUSSION_PROMPTS
} from "@pathwright/web/src/modules/discussion/list/utils"
import StepDiscussionContainer from "./StepDiscussionContainer"

const StepDiscussion = ({ step, canStartDiscussion, t }) => (
  <StepDiscussionContainer
    step={step}
    canStartDiscussion={canStartDiscussion}
    createTypes={[DISCUSSION_TYPE_POST]}
  >
    {({ context, onStartDiscussion, onSelectDiscussion }) => (
      <Discussions.Container
        context={context}
        onStartDiscussion={onStartDiscussion}
        onSelectDiscussion={onSelectDiscussion}
        filter={DISCUSSION_CONTROL_FILTER_DISCUSSION_QUESTIONS}
        sort={DISCUSSION_CONTROL_SORT_STEP_DISCUSSION_PROMPTS}
        initialLoadingCount={0}
        showReplyPrompt
      >
        <Discussions.List>
          {
            // hiding blank slate
            () => null
          }
        </Discussions.List>
        {!!onStartDiscussion && (
          <Discussions.StartDiscussion
            label={t("Post a discussion prompt")}
            styleType="empty"
            stretch
            inverted={false}
            style={{ height: "50px" }}
            tooltip={
              <span>
                {t(
                  "Prompt learners to apply what they're learning in this step with other learners."
                )}
                <br />
                <br />
                <Button
                  styleType="text"
                  href="https://www.pathwright.com/blog/how-to-write-discussion-questions/"
                  target="_blank"
                  label={t("Learn more about writing discussion prompts")}
                  postIcon="external-link"
                  inverted
                ></Button>
              </span>
            }
          />
        )}
      </Discussions.Container>
    )}
  </StepDiscussionContainer>
)

StepDiscussion.displayName = "StepDiscussion"

export default withTranslate(StepDiscussion)
